import React, { useEffect } from 'react';
import ScrollContainer from '../../../../Base/Components/ScrollContainer';
import FlatList from '../../../../Base/Components/FlatList';
import { Group, useWorkplaceGroupsQuery } from '../../../../../graphql/graphql';
import EArchiveGroupListItem from '../EArchiveGroupListItem/EArchiveGroupListItem';
import styles from './EArchiveGroupsList.module.scss';
import useFlatPages from '../../../../Base/Hooks/useFlatPages';
import Loading from '../../../../../Components/Loading';
import { useGroupsContext } from '../../../Services/GroupsContext';

const WRAPPER_ID = 'eArchiveGroupList';
const PAGINATION_TAKE = 48;

const EArchiveGroupsList = () => {
	const { page, getNextPage, pagination } = useFlatPages(PAGINATION_TAKE);
	const { data, isLoading, refetch } = useWorkplaceGroupsQuery({ pagination });
	const { createGroupMode } = useGroupsContext();

	useEffect(() => {
		// createGroupMode is reset when new group is created
		if (typeof createGroupMode === 'undefined') {
			refetch();
		}
	}, [createGroupMode]);

	if (isLoading) {
		return <Loading />;
	}

	const totalPages = data?.workplaceGroups?.meta?.totalPages || 0;

	return (
		<ScrollContainer wrapperId={WRAPPER_ID} className={styles.background}>
			<FlatList
				onRefresh={refetch}
				onLoadMore={getNextPage}
				data={data?.workplaceGroups?.data || []}
				isLoading={isLoading}
				hasMoreData={totalPages > page}
				scrollableTargetId={WRAPPER_ID}
				itemKey='id'
				className={styles.grid}
				renderItem={(group: Group) => (
					<EArchiveGroupListItem group={group} refetchGroups={refetch} />
				)}
			/>
		</ScrollContainer>
	);
};

export default EArchiveGroupsList;
